// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../common.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Users page only */
.admin-modal {
  max-width: 480px;
}

.admin-user-email {
  color: #3b82f6;
  text-decoration: underline;
  cursor: pointer;
}

.admin-user-email:hover {
  color: #2563eb;
}

.admin-input.admin-select {
  cursor: pointer;
}

.admin-field-hint {
  display: block;
  font-size: 12px;
  color: #94a3b8;
  margin-top: 4px;
}

.admin-username-sla-note {
  font-weight: 500;
  color: #64748b;
  font-size: 12px;
}

.admin-password-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.admin-password-wrap .admin-input {
  padding-right: 44px;
}

.admin-password-toggle {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-password-toggle:hover {
  color: #1a202c;
}

.admin-checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #475569;
  cursor: pointer;
  font-weight: 500;
}

.admin-checkbox-label input {
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/Users/index.css"],"names":[],"mappings":"AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["@import \"../common.css\";\n\n/* Users page only */\n.admin-modal {\n  max-width: 480px;\n}\n\n.admin-user-email {\n  color: #3b82f6;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.admin-user-email:hover {\n  color: #2563eb;\n}\n\n.admin-input.admin-select {\n  cursor: pointer;\n}\n\n.admin-field-hint {\n  display: block;\n  font-size: 12px;\n  color: #94a3b8;\n  margin-top: 4px;\n}\n\n.admin-username-sla-note {\n  font-weight: 500;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.admin-password-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.admin-password-wrap .admin-input {\n  padding-right: 44px;\n}\n\n.admin-password-toggle {\n  position: absolute;\n  right: 12px;\n  background: none;\n  border: none;\n  color: #64748b;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.admin-password-toggle:hover {\n  color: #1a202c;\n}\n\n.admin-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  color: #475569;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.admin-checkbox-label input {\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
